import http from '../http-common'

const types = () => {
 return http.get('/form-types')
}


export const formTypesService = {
    types
}